import React from 'react';
import { Link } from 'react-router-dom';
import logComponent from '../../common/logComponent';

export default function Tab({ title, badge, linkPath }) {
  if (logComponent('Tab')) { console.debug('Tab rendered'); }

  return (
    <Link
      to={linkPath}
      className="TabPanel__tab-link">
      {title}
      {
        badge ?
          <span className="TabPanel__tab-badge">{badge}</span> :
          null
      }
    </Link>
  );
}